const ITEMS = [
  "Next to Glebe Park",
  "Canberra City",
  "Dr Avantica Gupta & Dr Peter Stejskal",
  "Check-ups & Cleans",
  "Same-Day Crowns",
  "Clear Aligners",
  "Sedation for Anxious Patients",
  "Kids Welcome",
  "HICAPS on the Spot",
  "New Patients Welcome",
];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {ITEMS.map((item) => (
      <span key={item} className="flex items-center">
        <span className="whitespace-nowrap px-8 font-serif text-xl italic tracking-wide text-fern/80 sm:text-2xl">
          {item}
        </span>
        <span className="h-1.5 w-1.5 rounded-full bg-leaf/50" />
      </span>
    ))}
  </div>
);

const Marquee = () => (
  <div
    data-testid="editorial-marquee"
    className="border-y border-stone/70 bg-sage"
    aria-hidden="true"
  >
    <div className="hidden overflow-hidden py-6 sm:block">
      <div className="animate-marquee flex w-max">
        <Row />
        <Row />
      </div>
    </div>
    <div className="flex flex-wrap items-center justify-center gap-x-5 gap-y-2 px-5 py-5 sm:hidden">
      {ITEMS.map((item) => (
        <span key={item} className="font-serif text-base italic text-fern/80">
          {item}
        </span>
      ))}
    </div>
  </div>
);

export default Marquee;
